export default {
    default: {
        actions: 'Ações',
        edit: 'Editar',
        add: 'Adicionar {resource}',
        show: 'Visualizar',
        delete: 'Excluir',
        sync: 'Sincronizar',
        activate: 'Ativar',
        yes: 'Sim',
        no: 'Não',
        active: 'Ativo',
        inactive: 'Inativo',
    },

    dialogs: {
        confirm: {
            delete: {
                title: 'Confirmar Exclusão ?',
                content: ctx =>
                    `Tem certeza que deseja excluir ${
                        ctx.named('article') ? ctx.named('article') : 'o'
                    } ${ctx.named('resource')}${
                        ctx.named('name')
                            ? ': <b>' + ctx.named('name') + '</b>'
                            : ''
                    }?`,
            },
            restore: {
                title: 'Confirmar Restauração ?',
                content:
                    'Tem certeza que deseja resturar o {resource}: {name}?',
            },
            cancel: {
                title: 'Confirmar Cancelamento ?',
                content: ctx =>
                    `Tem certeza que deseja cancelar ${
                        ctx.named('article') ? ctx.named('article') : 'o'
                    } ${ctx.named('resource')}${
                        ctx.named('name')
                            ? ': <b>' + ctx.named('name') + '</b>'
                            : ''
                    } ?`,
                confirm: 'Confirmar',
            },
        },
    },

    feedbacks: {
        errors: {
            delete: 'Não foi possível excluir o {resource}.',
            restore: 'Não foi possível resturar o {resource}.',
            loadingList: 'Não foi possível carregar a lista de {resource}.',
            copy: 'Erro ao copiar o {resource}.',
        },

        success: {
            delete: '{resource} excluído com sucesso!',
            restore: '{resource} resturado com sucesso!',
            copy: '{resource} copiado com sucesso!',
            sync: '{resource} sincronizado com sucesso!',
            cancel: 'Cancelado com succoesso.',
        },
    },

    address: {
        name: 'Endereço | Endereços',
        attributes: {
            active: 'Ativo',
            addressShort: 'Endereço',
            city: 'Cidade',
            complement: 'Complemento',
            district: 'Bairro',
            number: 'Número',
            readableCity: 'Cidade/Estado',
            state: 'Estado',
            street: 'Rua',
            zipCode: 'CEP',
            fiscalAddress: 'Endereço Fiscal',
        },

        errors: {
            'zip-code-required': 'O CEP é obrigatório',
            'zip-code-max-length': 'O CEP deve ter no máximo 9 caracteres',
            'street-required-if': 'A rua é obrigatória',
            'street-max-length': 'A rua deve ter no máximo 100 caracteres',
            'number-max-length': 'O número deve ter no máximo 10 caracteres',
            'district-required-if': 'O bairro é obrigatório',
            'district-max-length': 'O bairro deve ter no máximo 80 caracteres',
            'complement-max-length':
                'O complemento deve ter no máximo 255 caracteres',
            'city-required-if': 'A cidade é obrigatória',
        },

        getters: {
            active: {
                true: 'Sim',
                false: 'Não',
            },
            fiscalAddress: {
                true: 'Sim',
                false: 'Não',
            },
        },
    },

    bill: {
        name: 'Fatura | Faturas',
        attributes: {
            discount: 'Desconto',
            dueAt: 'Data de Vencimento',
            interest: 'Juros',
            totalValue: 'Valor Total',
            value: 'Valor',
        },
        getters: {
            status: {
                paid: 'Pago',
                pending: 'Pendente',
            },
        },
    },

    customer: {
        name: 'Cliente | Clientes',
        attributes: {
            reseller_id: 'Parceiro',
            legal_name: 'Razão Social',
            trade_name: 'Nome Fantasia',
            contacts: 'Contatos',
            created_at: 'Criado em',
            status: 'Status',
            activated_at: 'Ativado em',
            canceled_at: 'Cancelado em',
            deleted_at: 'Excluído em',
        },
        getters: {
            status: {
                trial: 'Trial',
                expired: 'Expirado',
                active: 'Ativo',
                blocked: 'Bloqueado',
                cancellation_requested: 'Cancelamento Solicitado',
                canceled: 'Cancelado',
                deleted: 'Excluído',
            },
        },
    },

    mail: {
        name: 'E-mail | E-mails',
        attributes: {
            subject: 'Assunto',
            recipients: 'Destinatários',
            bcc: 'Cópia Oculta',
            variables: 'Variáveis',
            content: 'Conteúdo',
        },
        hints: {
            subject: 'Assunto do E-mail',
            recipients: 'Destinatários separado por ";"',
            content: 'Conteúdo do E-mail',
        },
    },

    partner: {
        name: 'Parceiro | Parceiros',
    },

    planPackage: {
        name: 'Pacote de Plano | Pacotes de Planos',
    },

    planPackageModule: {
        name: 'Módulo | Módulos',
    },

    product: {
        name: 'Produto | Produtos',
        attributes: {
            name: 'Nome',
            price: 'Preço',
            installments: 'Parcelas',
        },
    },

    productSale: {
        name: 'Venda | Vendas',
        attributes: {
            reseller_id: 'Parceiro',
            product_id: 'Produto',
            price: 'Preço',
            installments: 'Parcelas',
            payment_method: 'Forma de Pagamento',
            reseller_name: 'Nome do Parceiro',
            product_name: 'Nome do Produto',
            first_due_date: 'Primeiro Vencimento',
            charge: 'Realizar Cobrança',
            charged: 'Cobrança Realizada',
            status: 'Status',
            down_payment: {
                price: 'Valor',
                payment_method: 'Forma de Pagamento',
                due_at: 'Vencimento',
            },
        },

        getters: {
            payment_method: {
                bank_slip: 'Boleto',
                pix: 'PIX',
                credit_card: 'Cartão de Crédito',
                pix_bank_slip: 'Boleto/Pix',
            },
        },

        hints: {
            charge: 'Gera a cobrança da venda no gateway de pagamento.',
        },

        simulator: {
            title: 'Simulação de Venda',
            close: 'Fechar',
        },
    },

    productSalePeriod: {
        name: 'Período | Períodos',
        attributes: {
            payment_method: 'Forma de Pagamento',
            installment: 'Parcela',
            price: 'Valor',
            due_at: 'Data de vencimento',
            paid_at: 'Pago em',
            status: 'Status',
            price_paid: 'Valor Pago',
            url: 'Link',
        },
        getters: {
            payment_method: {
                bank_slip: 'Boleto',
                pix: 'PIX',
                credit_card: 'Cartão de Crédito',
                pix_bank_slip: 'Boleto/Pix',
            },
            installment: {
                0: 'Entrada',
            },
        },
        hints: {
            copyUrl: 'Copiar url da página de pagamento',
            accessPaymentPage: 'Acessar página de pagamento',
            cancel: 'Cancelar Cobrança',
        },
    },

    reseller: {
        name: 'Parceiro | Parceiros',
        attributes: {
            status: 'Status',
            manager_id: 'Gerente de Conta',
            notify_customers: 'Notificar Clientes',
            customers_canceled: 'Clientes Cancelados',
        },
        getters: {
            status: {
                new: 'Em Cadastro',
                pendent: 'Pendente',
                active: 'Ativo',
                blocked: 'Bloqueado',
                canceled: 'Cancelado',
                deleted: 'Excluído',
            },
        },
    },

    settings: {
        name: 'Configuração | Configurações',
        attributes: {
            slug: 'Slug',
            name: 'Nome',
            value: 'Valor',
        },
        errors: {
            'slug-required': 'O slug é obrigatório',
            'name-required': 'O nome é obrigatório',
            'value-required': 'O valor é obrigatório',
        },
    },

    notification: {
        name: 'Notificação | Notificações',
        attributes: {
            title: 'Título',
            description: 'Descrição',
            type: 'Notificação para',
            days: 'Dias',
            when: 'Período',
            action: 'Ação',
            status: 'Status',
            exibition: 'Exibição',
        },
        actions: {
            due_date: 'vencimento',
        },
        when: {
            before: 'antes',
            on_day: 'no dia',
            after: 'depois',
        },
        hints: {
            description: 'Mensagem que será exibida ao usuário',
        },
    },
}
